module.exports = __webpack_public_path__ + "img/bicycle-none-left.c04b223e.jpg";